import axios from './axios';

const getMetricsAlertHistory = params =>
  axios({
    method: 'get',
    url: '/v2/machines/metrics/alert-history',
    params
  });

export { getMetricsAlertHistory };
